import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

import { STACK_ROLES_COLUMN_ID } from "../constants";
import StackRolesNameCell from "./NameCell";
import StackRolesDescriptionCell from "./DescriptionCell";
import StackRolesSpaceCell from "./SpaceCell";
import StackRolesRowActionsCell from "./RowActionsCell";

const STACK_ROLES_CELLS: TableCellPerColumn<StackRoleBindingView> = {
  [STACK_ROLES_COLUMN_ID.ROLE]: StackRolesNameCell,
  [STACK_ROLES_COLUMN_ID.DESCRIPTION]: StackRolesDescriptionCell,
  [STACK_ROLES_COLUMN_ID.SPACE]: StackRolesSpaceCell,
  [STACK_ROLES_COLUMN_ID.ROW_ACTIONS]: StackRolesRowActionsCell,
};

export default STACK_ROLES_CELLS;
